import React from "react";
import PropTypes from "prop-types";
import styles from "./EventHeader.module.css";

export function EventHeader({ location, date }) {
  return (
    <div>
      <div className={styles.eventHeader}>
        <div className={styles.location}>{location}</div>
        <div className={styles.date}>{date}</div>
      </div>
      <div className={styles.divider} />
    </div>
  );
}

EventHeader.propTypes = {
  location: PropTypes.string.isRequired,
  date: PropTypes.string.isRequired,
};
